<template>
  <div class="block-layout questionnaire que_tmp_parent" id="scrollableques" v-if="isEveryThingLoaded">
    <button v-if="isEdit" class="questionary_save r130" @click="saveMe(true)">Update</button> 
    <div
      class="vx-col w-full wizard-container form_section questionnairesection pad0 case-form-v2"
    >
      <div class="questionnaire_page" id="questionnaire_page">
        <div class="questionnaire_sec">
          <div class="questionnaire_titles">
            <div class="questionnaire_titles_info">
              <h2>Questionnaire for PERM</h2>
              <p>Please take a few moments to complete this short registration form</p>
               <ul>
                <li :class="{'active':['PERM Application','Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='PERM Application'"  class="active"><span>1</span><a>PERM Application</a></li>
                <li :class="{'active':['Personal Info' ,'Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Personal Info'"  ><span>2</span><a>Personal Info</a></li>
                <li :class="{'active':['Educational Info','Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Educational Info'"><span>3</span><a>Educational Info</a></li>
                <li :class="{'active':['Employement Info' ,'Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Employement Info'"><span>4</span><a>Employment Info</a></li>
                <li :class="{'active':['Documents Info' ,'Dependents Info' ].indexOf(currentTab)>-1}" @click="currentTab='Documents Info'"><span>5</span><a>Documents Info</a></li>
                <li :class="{'active':['Dependents Info'].indexOf(currentTab)>-1}" @click="currentTab='Dependents Info'"><span>6</span><a>Dependents Info</a></li>
              </ul>
            </div>
            <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
          </div>
          <div class="questionnaire_form questionnaire_template_form">
            <div v-if="currentTab=='PERM Application'">
              <form data-vv-scope="beneficiaryInfoform" @submit.prevent="" @keydown.enter.prevent="">
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                  <h3 class="small-header">Alien Information</h3>
                  <div class="vx-row">
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'isTrainigRequired'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is training required for the job opportunity? </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'isTrainigRequired'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'isTrainigRequired'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'isTrainigRequired'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.isTrainigRequired"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'isTrainigRequired' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'isExpRequired'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is experience in the job offered required for the job? </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'isExpRequired'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'isExpRequired'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'isExpRequired'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.isExpRequired"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'isExpRequired' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div> 
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'isWorkingWithPetngEmplr'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is the alien currently employed by the petitioning employer?</h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'isWorkingWithPetngEmplr'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'isWorkingWithPetngEmplr'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'isWorkingWithPetngEmplr'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.isWorkingWithPetngEmplr"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'isWorkingWithPetngEmplr' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'isAltCombOfEduAndExpAccept'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is there an alternate combination of education and experience that is acceptable </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'isAltCombOfEduAndExpAccept'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'isAltCombOfEduAndExpAccept'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'isAltCombOfEduAndExpAccept'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.isAltCombOfEduAndExpAccept"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'isAltCombOfEduAndExpAccept' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'acceptAnyCombination'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Are you willing to accept any suitable combination of education, experience, or training </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'acceptAnyCombination'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'acceptAnyCombination'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'acceptAnyCombination'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.acceptAnyCombination"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'acceptAnyCombination' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'isExpInAltOccuAccept'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is experience in an alternate occupation acceptable?</h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'isExpInAltOccuAccept'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'isExpInAltOccuAccept'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'isExpInAltOccuAccept'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.isExpInAltOccuAccept"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'isExpInAltOccuAccept' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'hasGainAnyExpWithEmplr'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Did the alien gain any of the qualifying experience with the employer in a position substantially comparable to the job opportunity requested?</h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'hasGainAnyExpWithEmplr'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'hasGainAnyExpWithEmplr'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'hasGainAnyExpWithEmplr'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.hasGainAnyExpWithEmplr"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'hasGainAnyExpWithEmplr' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'alienInfo',key: 'didEmplrPayForEdu'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Did the employer pay for any of the alien’s education or training necessary to satisfy any of the employer’s job requirements for this position? </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'alienInfo',key:'didEmplrPayForEdu'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'alienInfo',key:'didEmplrPayForEdu'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'alienInfo',key:'didEmplrPayForEdu'})">
                                    <vs-checkbox
                                  
                                    v-model="alienInfo.didEmplrPayForEdu"
                                    @change="
                                      selectCheck({ section: 'alienInfo', key: 'didEmplrPayForEdu' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                
                  </div>
                </div>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                <div class="form-container pt-0 questionnaire_hb form-container_QT">
                  <h3 class="small-header">Refiling Instructions</h3>
                  <div class="vx-row">
                    <div class="vx-col w-full mb-5 beneficiary-info-btns" v-if="showOrHideField({section: 'refilingInstructions',key: 'useFilingDateFromPrevSubtn'})" >
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <h6>Is training required for the job opportunity? </h6>
                          <!-- <label class="form_label">Is training required for the job opportunity?</label> -->
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'refilingInstructions',key:'useFilingDateFromPrevSubtn'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'refilingInstructions',key:'useFilingDateFromPrevSubtn'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'refilingInstructions',key:'useFilingDateFromPrevSubtn'})">
                                    <vs-checkbox
                                  
                                    v-model="refilingInstructions.useFilingDateFromPrevSubtn"
                                    @change="
                                      selectCheck({ section: 'refilingInstructions', key: 'useFilingDateFromPrevSubtn' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                        </div>
                        
                      <div class="list-radio-wrap">
                        <!-- <h6>Is training required for the job opportunity? </h6> -->
                        <ul class="list-radio" vs-type="flex" vs-align="center">
                        <li class="active" > <span>Yes</span></li>
                        <li > <span>No</span></li>
                        </ul>
                      </div>
                    </div>
                    </div>
                    <div class="vx-col w-full" v-if="showOrHideField({section: 'refilingInstructions',key: 'prevFilingDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Previous filing date<em v-if="refilingInstructions.prevFilingDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'refilingInstructions',key:'prevFilingDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'refilingInstructions',key:'prevFilingDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'refilingInstructions',key:'prevFilingDate'})">
                                    <vs-checkbox
                                  
                                    v-model="refilingInstructions.prevFilingDate"
                                    @change="
                                      selectCheck({
                                        section: 'refilingInstructions',
                                        key: 'prevFilingDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                    </div>
                    <div class="vx-col w-full" v-if="showOrHideField({section: 'refilingInstructions',key: 'prevSWAOrLocalCaseNo'})">
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"
                            >Indicate the previous SWA or local office case number OR if not available, specify state where case was originally filed.<em v-if="refilingInstructions.prevSWAOrLocalCaseNo">*</em></label
                          >
                          <div class="check_box_container"  v-if="isEdit">
                      <div class="check_box_list" @click="toogleFields({section:'refilingInstructions',key:'prevSWAOrLocalCaseNo'})">
                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'refilingInstructions',key:'prevSWAOrLocalCaseNo'})}" >
                        <span class="checkmark" >
                          <i class="material-icons">check</i>
                        </span>
                        </span>
                        <div class="tooltip_cnt">
                        <p>Field is required</p>
                        </div>
                      </div>
                      <div class="check_box_list" v-if="checkFieldRequired({section:'refilingInstructions',key:'prevSWAOrLocalCaseNo'})">
                        <vs-checkbox
                      
                        v-model="refilingInstructions.name"
                            @change="
                              selectCheck({
                                section: 'refilingInstructions',
                                key: 'prevSWAOrLocalCaseNo',
                              })
                            "
                        ></vs-checkbox>
                        <div class="tooltip_cnt">
                        <p>Validation is required</p>
                        </div>
                      </div>
                      </div>
                          
                        </div>
                        <vs-input
                          type="text"
                          name="school/CollegeName"
                          class="w-full no-icon-border"
                        />
                      </div>
                    </div>
                    
                  </div>
                </div>
                </vs-col>
              </form>  
            </div>
            <div v-if="currentTab=='Personal Info'">
              <form data-vv-scope="beneficiaryInfoform" @submit.prevent="" @keydown.enter.prevent="">
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 questionnaire_hb form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'gender'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Gender<em v-if="beneficiaryInfo.gender">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'gender'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'gender'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'gender'})">
                              <vs-checkbox
                             
                                v-model="beneficiaryInfo.gender"
                                @change="
                                  selectCheck({
                                    section: 'beneficiaryInfo',
                                    key: 'gender',
                                  })
                                "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                          </div>
                            
                          </div>
                          <vx-input-group class="form-input-group FML">
                            <vs-button
                              class="btn male-btn"
                              icon-pack="IntakePortal"
                              icon=" IP-femenine-1"
                              type="border"
                              >Male</vs-button
                            >
                            <vs-button
                              class="btn female-btn"
                              icon-pack="IntakePortal"
                              icon=" IP-femenine-1"
                              type="border"
                              >Female</vs-button
                            >
                            <vs-button
                              class="btn others-btn"
                              icon-pack="feather"
                              icon="icon-circle"
                              type="border"
                              >Others</vs-button
                            >
                          </vx-input-group>
                        </div>
                      </div>
                      <div class="divider full-divider mb-10"></div>
                      <div class="vx-col w-full" >
                        <vx-input-group class="form-input-group FML">
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'firstName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">First Name<em v-if="beneficiaryInfo.firstName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'firstName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'firstName'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.firstName"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'firstName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                              <vs-input
                                type="text"
                                name="majorFieldOfStudy"
                                class="w-full no-icon-border"
                                placeHolder=""
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'middleName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Middle Name<em v-if="beneficiaryInfo.middleName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'middleName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'middleName'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.middleName"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'middleName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                              <vs-input
                                type="text"
                                name="majorFieldOfStudy"
                                class="w-full no-icon-border"
                                placeHolder=""
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full"  v-if="showOrHideField({section: 'beneficiaryInfo',key: 'lastName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Last Name <em v-if="beneficiaryInfo.lastName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'lastName'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'lastName'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.lastName"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'lastName',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                                
                              </div>
                              <vs-input
                                type="text"
                                name="majorFieldOfStudy"
                                class="w-full no-icon-border"
                                placeHolder=""
                              />
                            </div>
                          </div>
                        </vx-input-group>
                      </div>
                      <div class="vx-col md:w-full w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'email'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Email<em v-if="beneficiaryInfo.email">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'email'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'email'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'email'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.email"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo', key: 'email' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                           
                          </div>
                          <vs-input
                            type="email"
                            name="email"
                            class="w-full no-icon-border"
                            placeHolder=""
                          />
                        </div>
                      </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'previouslyMarried'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Were you married previously? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'previouslyMarried'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previouslyMarried"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo',
                                   key: 'previouslyMarried',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="divider full-divider mb-10"></div>
                     <div class="vx-col w-full" v-if="checkSpouseLabel({section:'beneficiaryInfo.previousSpouse'})" >
                       <div class="form_group w-full">
                         <label class="form_label"
                           ><h3 class="small-header">Previous Spouse
                            <div class="check_box_container"  v-if="isEdit">
                              <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})}" >
                                  <span class="checkmark" >
                                    <i class="material-icons">check</i>
                                  </span>
                                </span>
                                <div class="tooltip_cnt">
                                  <p>Field is required</p>
                                </div>
                              </div>
                              <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'previousSpouse'})">
                                <vs-checkbox
                              
                                v-model="
                              beneficiaryInfo.previousSpouse.previousSpouse
                            "
                            @change="
                              selectCheck({
                                section: 'beneficiaryInfo.previousSpouse',
                                key: 'previousSpouse',
                              })
                            "
                                ></vs-checkbox>
                                <div class="tooltip_cnt">
                                  <p>Validation is required</p>
                                </div>
                              </div>
                            </div>
                           </h3> 
                         </label>
                       </div>
                     </div>  
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'firstName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">First Name<em v-if="beneficiaryInfo.previousSpouse.firstName">*</em></label>

                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'firstName'})">
                            
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.firstName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'firstName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'middleName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Middle Name<em v-if="beneficiaryInfo.previousSpouse.middleName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'middleName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.middleName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'middleName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'lastName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Last Name<em v-if="beneficiaryInfo.previousSpouse.lastName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'lastName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.lastName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'lastName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'maidenName'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Maiden Name (if any)<em v-if="beneficiaryInfo.previousSpouse.maidenName">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'maidenName'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.maidenName"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'maidenName',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfBirth'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.previousSpouse.dateOfBirth">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfBirth'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfBirth"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfBirth',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'dateOfMarriageEnd'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Date of Marriage End<em v-if="beneficiaryInfo.previousSpouse.dateOfMarriageEnd">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'dateOfMarriageEnd'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.dateOfMarriageEnd"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'dateOfMarriageEnd',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div
                           class="mx-datepicker pad5"
                           typeable="true"
                           name="dfdateOfBirth"
                           data-vv-as="Date of Birth"
                         >
                           <div class="vs-con-input">
                             <Datepicker
                               format="MM/DD/YYYY"
                               placeholder="MM/DD/YYYY"
                               :disabled="true"
                             ></Datepicker>
                           </div>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Marriage<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Marriage<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriage'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Marriage<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriage">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriage'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriage"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriage',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'countryOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Country of Termination<em v-if="beneficiaryInfo.previousSpouse.countryOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'countryOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.countryOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'countryOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'provinceOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Provience of Termination<em v-if="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'provinceOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.provinceOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'provinceOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'locationOfMarriageTermination'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Location of Termination<em v-if="beneficiaryInfo.previousSpouse.locationOfMarriageTermination">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'locationOfMarriageTermination'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.locationOfMarriageTermination"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'locationOfMarriageTermination',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input type="text" class="vs-inputx vs-input--input normal" :disabled="true"/>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedDueTo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Marriage Ended Due To<em v-if="beneficiaryInfo.previousSpouse.marriageEndedDueTo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedDueTo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedDueTo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedDueTo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="con-select w-full">
                           <multiselect :options="[]" placeholder="Select" :disabled="true">
                           </multiselect>
                         </div>
                       </div>
                     </div>
                     <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'marriageEndedOtherInfo'})">
                       <div class="form_group mt-datepicker-wrap">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">If, Marriage Ended<em v-if="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'marriageEndedOtherInfo'})">
                             <vs-checkbox
                            
                             v-model="beneficiaryInfo.previousSpouse.marriageEndedOtherInfo"
                             @change="
                               selectCheck({
                                 section: 'beneficiaryInfo.previousSpouse',
                                 key: 'marriageEndedOtherInfo',
                               })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                           
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                      <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.previousSpouse',key: 'obtainPermResidenceThroughSpouse'})" >
                       <div class="d-flex align-center">
                         <a class="switch-label mr-3"> Did you obtain U.S Permanent Residence Through Spouse? </a>
                         <vs-switch>
                           <span slot="on">Yes</span>
                           <span slot="off">No</span>
                         </vs-switch>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.previousSpouse',key:'obtainPermResidenceThroughSpouse'})">
                             <vs-checkbox
                            
                               v-model="beneficiaryInfo.previousSpouse.obtainPermResidenceThroughSpouse"
                               @change="
                                 selectCheck({
                                   section: 'beneficiaryInfo.previousSpouse',
                                   key: 'obtainPermResidenceThroughSpouse',
                                 })
                               "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>


















                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'cellPhoneNumber'})">
                        <div class="form_group ph_number">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="beneficiaryInfo.cellPhoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'cellPhoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.cellPhoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'cellPhoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                           
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :no-country-selector="false"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'homePhoneNumber'})">
                        <div class="form_group ph_number">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Home Phone Number<em v-if="beneficiaryInfo.homePhoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'homePhoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.homePhoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'homePhoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                           
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Home Phone Number"
                              name="phone"
                              placeholder="Home Phone Number"
                              :no-country-selector="false"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'workPhoneNumber'})">
                        <div class="form_group ph_number">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Work Phone Number<em v-if="beneficiaryInfo.workPhoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'workPhoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'workPhoneNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'workPhoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.workPhoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'workPhoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                           
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Work Phone Number"
                              name="phone"
                              placeholder="Work Phone Number"
                              :no-country-selector="false"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'fax'})">
                        <div class="form_group ph_number">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Fax Number<em v-if="beneficiaryInfo.fax">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'fax'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'fax'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'fax'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.fax"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo', key: 'fax' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                           
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Fax Number"
                              name="phone"
                              placeholder="Fax Number"
                              :no-country-selector="false"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'dateOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Date of Birth<em v-if="beneficiaryInfo.dateOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.dateOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'dateOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfBirth'})">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country of Birth<em v-if="beneficiaryInfo.countryOfBirth">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'countryOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.countryOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'countryOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                             
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Country of Birth"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'provinceOfBirth'})">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Province of Birth<em v-if="beneficiaryInfo.provinceOfBirth">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'provinceOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.provinceOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'provinceOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                              
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Province of Birth"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'locationOfBirth'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Location of Birth<em v-if="beneficiaryInfo.locationOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'locationOfBirth'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'locationOfBirth'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.locationOfBirth"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'locationOfBirth',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <vs-input
                            type="text"
                            name="locationofBirth"
                            class="w-full no-icon-border"
                          />
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'countryOfCitizenship'})">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Country of Citizenship<em v-if="beneficiaryInfo.countryOfCitizenship">*</em></label>
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'countryOfCitizenship'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.countryOfCitizenship"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'countryOfCitizenship',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                             
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Country of Citizenship"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Passport<em v-if="beneficiaryInfo.passportNumber">*</em>
                              <div class="IB_tooltip">
                                <span
                                  ><info-icon size="1.5x" class="custom-class"></info-icon
                                ></span>
                                <div class="tooltip_cnt">
                                  <p>
                                    Make sure you input the most recent passport
                                    information. Also, note that the passport must have
                                    more than 6 months validity.
                                  </p>
                                </div>
                              </div>
                            </label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <vs-input
                            type="text"
                            name="passport"
                            class="w-full no-icon-border"
                          />
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportIssuedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Issued Date<em v-if="beneficiaryInfo.passportIssuedDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportIssuedDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportIssuedDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportIssuedDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'passportExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Passport Expiry Date<em v-if="beneficiaryInfo.passportExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'passportExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.passportExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'passportExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                           
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curNonImmigrantVisaStatus'})">
                        <div class="form_group">
                          <div class="con-select w-full select-large">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"
                                >Current Non-Immigrant Status<em v-if="beneficiaryInfo.curNonImmigrantVisaStatus">*</em></label
                              >
                              <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curNonImmigrantVisaStatus'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.curNonImmigrantVisaStatus"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'curNonImmigrantVisaStatus',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                             
                            </div>
                            <multiselect
                              name="Status"
                              :multiple="false"
                              :options="[]"
                              :hideSelected="true"
                              :close-on-select="true"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Nonimmigrant Status"
                              :preselect-first="false"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'curVisaExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status Expiry Date<em v-if="beneficiaryInfo.curVisaExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'curVisaExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.curVisaExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'curVisaExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>

                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Number<em v-if="beneficiaryInfo.I94">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.I94"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo', key: 'I94' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <vs-input
                            type="text"
                            name="I-94Number"
                            class="w-full no-icon-border"
                          />
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'I94ExpiryDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">I-94 Expiry Date<em v-if="beneficiaryInfo.I94ExpiryDate">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'I94ExpiryDate'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.I94ExpiryDate"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'I94ExpiryDate',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'firstEntryDateOrApprovalInUsWithH1B'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >First Entry Date or Approval in US With H1B<em v-if="beneficiaryInfo.firstEntryDateOrApprovalInUsWithH1B">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'firstEntryDateOrApprovalInUsWithH1B'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'firstEntryDateOrApprovalInUsWithH1B'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'firstEntryDateOrApprovalInUsWithH1B'})">
                                    <vs-checkbox
                                  
                                    v-model="
                                   beneficiaryInfo.firstEntryDateOrApprovalInUsWithH1B
                                  "
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'firstEntryDateOrApprovalInUsWithH1B',
                                    })
                                  "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                            
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'dateFifthYearOfHExpire'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date Fifth Year of H1B Status Expires<em v-if="beneficiaryInfo.dateFifthYearOfHExpire">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'dateFifthYearOfHExpire'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'dateFifthYearOfHExpire'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'dateFifthYearOfHExpire'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.dateFifthYearOfHExpire"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'dateFifthYearOfHExpire',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                           
                          </div>
                          <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                          </Datepicker>
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'SSN'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Social Security number (if applicable)<em v-if="beneficiaryInfo.SSN">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'SSN'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'SSN'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.SSN"
                                    @change="
                                      selectCheck({ section: 'beneficiaryInfo', key: 'SSN' })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                           
                          </div>
                          <vs-input
                            :patren="['### - ## - ####']"
                            datatype="min:9|max:9"
                            class="w-full no-icon-border"
                            placeHolder="123 - 45 - 6789"
                          />
                        </div>
                      </div>
                      <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'alienNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Your Alien Number (if applicable)<em v-if="beneficiaryInfo.alienNumber">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'alienNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'alienNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.alienNumber"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'alienNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                           
                          </div>
                          <vs-input
                            type="text"
                            name="alienNumber"
                            class="w-full no-icon-border"
                            placeHolder="Alien Number "
                          />
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'currentAddress'})">
                        <h3 class="small-header">
                          Current Address<em v-if="beneficiaryInfo.currentAddress">*</em>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'currentAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'currentAddress'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.currentAddress"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'currentAddress',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                         
                        </h3>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- mailingAddressIsSameAsAddress -->

                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'mailingAddress'})">
                        <div class="vx-col w-full d-flex">
                          <h3 class="small-header">Mailing Address<em v-if="beneficiaryInfo.mailingAddress">*</em></h3>
                          <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'mailingAddress'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'mailingAddress'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'mailingAddress'})">
                                    <vs-checkbox
                                  
                                    style="margin-left: 15px; margin-bottom: 12px"
                                    v-model="beneficiaryInfo.mailingAddress"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo',
                                        key: 'mailingAddress',
                                      })
                                    "
                                    >
                                    Same as Address</vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                          
                        </div>
                        <div class="vx-row">
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Street Address</label>
                              </div>
                              <vs-input
                                class="w-full"
                                v-validate="'required'"
                                data-vv-as="Street Address"
                              />
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Apt, Suite</label>
                              </div>
                              <div class="address-suite">
                                <ul
                                  class="demo-alignment custom-radio"
                                  vs-type="flex"
                                  vs-align="center"
                                >
                                  <li>
                                    <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                  </li>
                                  <li>
                                    <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                  </li>
                                </ul>
                                <vs-input class="" data-vv-as="Apt, Suite" />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Country</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select Country"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> State</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select State"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="con-select w-full select-large">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"> City</label>
                                </div>
                                <multiselect
                                  name="Status"
                                  :multiple="false"
                                  :options="[]"
                                  :hideSelected="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :preserve-search="true"
                                  placeholder="Select City"
                                  :preselect-first="false"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label for class="form_label">Zip Code</label>
                              </div>
                              <vs-input class="w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo',key: 'priorPeriodOfStayInUS'})">
                        <div class="form-container form-container-v2">
                          <div class="vx-row">
                            <div class="vx-col w-full mt-5 mb-5">
                              <h3 class="small-header">
                                Dates of Stay in USA<em v-if="beneficiaryInfo.priorPeriodOfStayInUS">*</em>
                                <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'priorPeriodOfStayInUS'})">
                                    <vs-checkbox   
                                  v-model="beneficiaryInfo.priorPeriodOfStayInUS"
                                  @change="
                                    selectCheck({
                                      section: 'beneficiaryInfo',
                                      key: 'priorPeriodOfStayInUS',
                                    })
                                  "
                                ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                                
                              </h3>
                              <p>
                                All prior periods of stay in the U.S. over the last seven
                                years
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full prior-stay-list periods-nowrap">
                          <div class="vx-row delete-row">
                            <div class="vx-col md:w-1/3 w-full">
                              <div class="form_group">
                                <div class="con-select w-full select-large">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">Visa Status</label>
                                  </div>
                                  <multiselect
                                    name="Status"
                                    :multiple="false"
                                    :options="[]"
                                    :hideSelected="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select Visa Status"
                                    :preselect-first="false"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/3 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Entered</label>
                                </div>
                                <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                                </Datepicker>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/3 w-full">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Date Departed</label>
                                </div>
                                <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                                </Datepicker>
                              </div>
                            </div>
                            <div class="delete">
                              <a>
                                <img src="@/assets/images/main/delete-row-img.svg">
                              </a>
                            </div>
                          </div>
                        </div>
                        <a class="add-more add-more-names ml-0 mt-0"><span>+</span>More</a>
                      </div>
                      <!--new-->
                      <template>
                        
                        <div class="vx-col w-full">
                          <h3 class="small-header" v-if=" showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'}) ||
                          showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'}) || showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'})
                          ">
                            Immigrant Petition Information<em v-if="beneficiaryInfo.immPetitionInfo">*</em>
                            <div class="check_box_container"  v-if="isEdit">
                                    <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo',key:'immPetitionInfo'})">
                                      <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionInfo'})}" >
                                        <span class="checkmark" >
                                          <i class="material-icons">check</i>
                                        </span>
                                      </span>
                                      <div class="tooltip_cnt">
                                        <p>Field is required</p>
                                      </div>
                                    </div>
                                    <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo',key:'immPetitionInfo'})">
                                      <vs-checkbox
                                    
                                      v-model="beneficiaryInfo.immPetitionInfo"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo',
                                            key: 'immPetitionInfo',
                                          })
                                        "
                                      ></vs-checkbox>
                                      <div class="tooltip_cnt">
                                        <p>Validation is required</p>
                                      </div>
                                    </div>
                                </div>
                          </h3>
                        </div>
                        
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'anyOtherAlienFiled'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Has any other Alien Employment Certification, a.k.a Labor Certification been filed on your behalf?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'anyOtherAlienFiled'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.anyOtherAlienFiled"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'anyImmPetitionFiled',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedDate'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label"
                              >Date Filed<em v-if="beneficiaryInfo.immPetitionInfo.filedDate">*</em></label
                            >
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedDate'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.filedDate"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo',
                                  key: 'filedDate',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div
                            class="mx-datepicker pad5"
                            typeable="true"
                            name="dfdateOfBirth"
                            data-vv-as="Date of Birth"
                          >
                            <div class="vs-con-input">
                              <Datepicker
                                format="MM/DD/YYYY"
                                placeholder="MM/DD/YYYY"
                              ></Datepicker>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'employerName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Name of the Employer<em v-if="beneficiaryInfo.immPetitionInfo.employerName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'employerName'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.employerName"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'employerName' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'rirOrRegularProcessing'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            RIR or Regular Processing
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'rirOrRegularProcessing'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.rirOrRegularProcessing"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'rirOrRegularProcessing',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'filedStateId'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">State where it was filed<em v-if="beneficiaryInfo.immPetitionInfo.filedStateId">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'filedStateId'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.filedStateId"
                              @change="
                                selectCheck({
                                  section: 'beneficiaryInfo.immPetitionInfo',
                                  key: 'filedStateId',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'applCurStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Status of the Application<em v-if="beneficiaryInfo.immPetitionInfo.applCurStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'applCurStatus'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.applCurStatus"
                              @change="
                                selectCheck({ section: 'beneficiaryInfo.immPetitionInfo', key: 'applCurStatus' })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                        </div>
                        <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.immPetitionInfo',key: 'seekingFiledDateforETA750'})">
                        <div class="d-flex align-center">
                          <a class="switch-label mr-3">
                            Are you seeking to utilize the filing date from a previously submitted Application for Alien Employment Certification (ETA 750)?
                          </a>
                          <vs-switch>
                            <span slot="on">Yes</span>
                            <span slot="off">No</span>
                          </vs-switch>
                          <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.immPetitionInfo',key:'seekingFiledDateforETA750'})">
                              <vs-checkbox
                             
                              v-model="beneficiaryInfo.immPetitionInfo.seekingFiledDateforETA750"
                              @change="
                              selectCheck({
                                section: 'beneficiaryInfo.immPetitionInfo',
                                key: 'seekingFiledDateforETA750',
                              })
                            "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                        </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--Educations-->
            <div v-if="currentTab=='Educational Info'">
              <form data-vv-scope="educationsInfoform" @submit.prevent="" @keydown.enter.prevent="">
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    After your 12th grade – Starting from the most recent degree first
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <h3 class="small-header">Educational Information
                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'educations'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'educations'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.educations.educations"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'educations',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="form-container questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="vx-row delete-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'name'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >University/College/School Name<em v-if="beneficiaryInfo.educations.name">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'name'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'name'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.educations.name"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.educations',
                                            key: 'name',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                      </div>
                                      
                                    </div>
                                    <vs-input
                                      type="text"
                                      name="school/CollegeName"
                                      class="w-full no-icon-border"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'highestDegree'})">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.educations.highestDegree">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'highestDegree'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.educations.highestDegree"
                                    @change="
                                      selectCheck({
                                      section: 'beneficiaryInfo.educations',
                                      key: 'highestDegree',
                                      })
                                    "
                                    ></vs-checkbox> 
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                            </div>
                                       
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Highest Degree"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'majorFieldOfStudy'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Major Field of Study<em v-if="beneficiaryInfo.educations.majorFieldOfStudy">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'majorFieldOfStudy'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.educations.majorFieldOfStudy"
                                    @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'majorFieldOfStudy',})"
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                      </div>
                                      
                                    </div>
                                    <vs-input
                                      type="text"
                                      name="majorFieldOfStudy"
                                      class="w-full no-icon-border"
                                      placeHolder="Major Field of Study"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'graduatedYear'})">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Year of Graduation<em v-if="beneficiaryInfo.educations.graduatedYear">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'graduatedYear'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.educations.graduatedYear"
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'graduatedYear',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                        
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Year of Graduation"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedFrom'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Course Started On<em v-if="beneficiaryInfo.educations.attendedFrom">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedFrom'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.educations.attendedFrom"
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'attendedFrom',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    >
                                    </Datepicker>
                                  </div>
                                </div>
                                <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'attendedTo'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Course Completed On<em v-if="beneficiaryInfo.educations.attendedTo">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'attendedTo'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.educations.attendedTo"
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'attendedTo',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    >
                                    </Datepicker>
                                  </div>
                                </div>
                                <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'address'})">
                                  <div>
                                    <h3 class="small-header">
                                      University/College/School Address<em v-if="beneficiaryInfo.educations.address">*</em>
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'address'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'address'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.educations.address"
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'address',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </h3>
                                    <div class="vx-row">
                                      <div class="vx-col md:w-1/2 w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"
                                              >Street Address</label
                                            >
                                          </div>
                                          <vs-input
                                            class="w-full"
                                            v-validate="'required'"
                                            data-vv-as="Street Address"
                                          />
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Apt, Suite</label>
                                          </div>
                                          <div class="address-suite">
                                            <ul
                                              class="demo-alignment custom-radio"
                                              vs-type="flex"
                                              vs-align="center"
                                            >
                                              <li>
                                                <vs-checkbox name="aptType1"
                                                  >Apt</vs-checkbox
                                                >
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType2"
                                                  >Ste</vs-checkbox
                                                >
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType3"
                                                  >Flr</vs-checkbox
                                                >
                                              </li>
                                            </ul>
                                            <vs-input class="" data-vv-as="Apt, Suite" />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> Country</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select Country"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> State</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select State"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> City</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select City"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label for class="form_label">Zip Code</label>
                                          </div>
                                          <vs-input class="w-full" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isAccredited'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Accredited at the time of your
                                        graduation?<em v-if="beneficiaryInfo.educations.isAccredited">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isAccredited'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.educations.isAccredited"
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'isAccredited',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.educations',key: 'isForProfit'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Profit University?<em v-if="beneficiaryInfo.educations.isForProfit">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.educations',key:'isForProfit'})">
                                          <vs-checkbox
                                        
                                          v-model=beneficiaryInfo.educations.isForProfit
                                          @change="selectCheck({section: 'beneficiaryInfo.educations',key: 'isForProfit',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="divider full-divider mb-10"></div>
                          <!-- <h3 class="small-header">Vocational or Training</h3> -->
                          <h3 class="small-header">Vocational or Training
                      <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'vacationalOrTrainingInst'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'vacationalOrTrainingInst'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'vacationalOrTrainingInst'})">
                                    <vs-checkbox
                                  
                                    v-model="beneficiaryInfo.vacationalOrTrainingInst.vacationalOrTrainingInst"
                                        @change="
                                          selectCheck({
                                            section: 'beneficiaryInfo.vacationalOrTrainingInst',
                                            key: 'vacationalOrTrainingInst',
                                          })
                                        "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>
                    </h3>
                          <div class="vx-row">
                            <div class="vx-col w-full">
                              <div class="vx-row delete-row">
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'name'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >University/College/School Name<em v-if="beneficiaryInfo.vacationalOrTrainingInst.name">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'name'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'name'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'name'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.name"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'name',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <vs-input
                                      type="text"
                                      name="University/College/School Name"
                                      class="w-full no-icon-border"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'highestDegree'})">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Highest Degree<em v-if="beneficiaryInfo.vacationalOrTrainingInst.highestDegree">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'highestDegree'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'highestDegree'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'highestDegree'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.highestDegree"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'highestDegree',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                        
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Highest Degree"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'majorFieldOfStudy'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Major Field of Study<em v-if="beneficiaryInfo.vacationalOrTrainingInst.majorFieldOfStudy">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'majorFieldOfStudy'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'majorFieldOfStudy'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'majorFieldOfStudy'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.majorFieldOfStudy"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'majorFieldOfStudy',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <vs-input
                                      type="text"
                                      name="majorFieldOfStudy"
                                      class="w-full no-icon-border"
                                      placeHolder="Major Field of Study"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'graduatedYear'})">
                                  <div class="form_group">
                                    <div class="con-select w-full select-large">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Year of Graduation<em v-if="beneficiaryInfo.vacationalOrTrainingInst.graduatedYear">*</em></label>
                                        <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'graduatedYear'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'graduatedYear'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'graduatedYear'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.graduatedYear"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'graduatedYear',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                       
                                      </div>
                                      <multiselect
                                        name="Status"
                                        :multiple="false"
                                        :options="[]"
                                        :hideSelected="true"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select Year of Graduation"
                                        :preselect-first="false"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'attendedFrom'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label">Course Started On<em v-if="beneficiaryInfo.vacationalOrTrainingInst.attendedFrom">*</em></label>
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedFrom'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedFrom'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedFrom'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.attendedFrom"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'attendedFrom',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    >
                                    </Datepicker>
                                  </div>
                                </div>

                                <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'attendedTo'})">
                                  <div class="form_group mt-datepicker-wrap">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Course Completed On<em v-if="beneficiaryInfo.vacationalOrTrainingInst.attendedTo">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedTo'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedTo'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'attendedTo'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.attendedTo"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'attendedTo',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                     
                                    </div>
                                    <Datepicker
                                      format="MM/DD/YYYY"
                                      placeholder="MM/DD/YYYY"
                                    >
                                    </Datepicker>
                                  </div>
                                </div>
                                <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'address'})">
                                  <div>
                                    <h3 class="small-header">
                                      University/College/School Address<em v-if="beneficiaryInfo.vacationalOrTrainingInst.address">*</em>
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'address'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'address'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.address"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'address',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </h3>
                                    <div class="vx-row">
                                      <div class="vx-col md:w-1/2 w-1/2">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label"
                                              >Street Address</label
                                            >
                                          </div>
                                          <vs-input
                                            class="w-full"
                                            v-validate="'required'"
                                            data-vv-as="Street Address"
                                          />
                                        </div>
                                      </div>

                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label class="form_label">Apt, Suite</label>
                                          </div>
                                          <div class="address-suite">
                                            <ul
                                              class="demo-alignment custom-radio"
                                              vs-type="flex"
                                              vs-align="center"
                                            >
                                              <li>
                                                <vs-checkbox name="aptType1"
                                                  >Apt</vs-checkbox
                                                >
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType2"
                                                  >Ste</vs-checkbox
                                                >
                                              </li>
                                              <li>
                                                <vs-checkbox name="aptType3"
                                                  >Flr</vs-checkbox
                                                >
                                              </li>
                                            </ul>
                                            <vs-input class="" data-vv-as="Apt, Suite" />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> Country</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select Country"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> State</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select State"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="con-select w-full select-large">
                                            <div class="d-flex align-end mb-1">
                                              <label class="form_label"> City</label>
                                            </div>
                                            <multiselect
                                              name="Status"
                                              :multiple="false"
                                              :options="[]"
                                              :hideSelected="true"
                                              :close-on-select="true"
                                              :clear-on-select="false"
                                              :preserve-search="true"
                                              placeholder="Select City"
                                              :preselect-first="false"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col md:w-1/2 w-full">
                                        <div class="form_group">
                                          <div class="d-flex align-end mb-1">
                                            <label for class="form_label">Zip Code</label>
                                          </div>
                                          <vs-input class="w-full" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'isAccredited'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Accredited at the time of your
                                        graduation?<em v-if="beneficiaryInfo.vacationalOrTrainingInst.isAccredited">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isAccredited'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isAccredited'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isAccredited'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.isAccredited"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'isAccredited',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                      
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'isForProfit'})">
                                  <div class="form_group">
                                    <div class="d-flex align-end mb-1">
                                      <label class="form_label"
                                        >Is the University Profit University?<em v-if="beneficiaryInfo.vacationalOrTrainingInst.isForProfit">*</em></label
                                      >
                                      <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isForProfit'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isForProfit'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.vacationalOrTrainingInst',key:'isForProfit'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.vacationalOrTrainingInst.isForProfit"
                                          @change="selectCheck({section: 'beneficiaryInfo.vacationalOrTrainingInst',key: 'isForProfit',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                     
                                    </div>
                                    <vs-switch>
                                      <span slot="on">Yes</span>
                                      <span slot="off">No</span>
                                    </vs-switch>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!--employment-->
            <div v-if="currentTab=='Employement Info'">
              <form
                data-vv-scope="employmentform"
                @submit.prevent=""
                @keydown.enter.prevent=""
              >
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    Provide your current and previous employment details, starting from
                    the most recent first.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <h3 class="small-header">Employement
                      <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                            <span class="checkmark" >
                              <i class="material-icons">check</i>
                            </span>
                            </span>
                            <div class="tooltip_cnt">
                            <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                            <vs-checkbox
                          
                            v-model="beneficiaryInfo.prevEmploymentInfo.prevEmploymentInfo"
                            @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'prevEmploymentInfo',})"
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                            <p>Validation is required</p>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="false&&checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'prevEmploymentInfo'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.prevEmploymentInfo"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'prevEmploymentInfo',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div> -->
                    </h3>
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="form-container alt-rows-bg questionnaire_hb">
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'employerName'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Employer Name<em v-if="beneficiaryInfo.prevEmploymentInfo.employerName">*</em>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Make sure to input your Employer information and
                                          not the Client details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'employerName'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.employerName"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'employerName',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                 
                                </div>
                                <vs-input
                                  type="text"
                                  name="employerName"
                                  class="w-full no-icon-border"
                                  placeHolder="Employer Name"
                                />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentEmployer'})">
                              <div class="d-flex align-center">
                                <label class="form_label mr-3"> Current Employer?<em v-if="beneficiaryInfo.prevEmploymentInfo.currentEmployer">*</em></label>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentEmployer'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.currentEmployer"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentEmployer',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentH1BEmployer'})">
                              <div class="d-flex align-center">
                                <label class="form_label mr-3">Is this your current H1B Job<em v-if="beneficiaryInfo.prevEmploymentInfo.currentH1BEmployer">*</em></label>
                                <vs-switch>
                                  <span slot="on">Yes</span>
                                  <span slot="off">No</span>
                                </vs-switch>
                                <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentH1BEmployer'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentH1BEmployer'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'currentH1BEmployer'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.currentH1BEmployer"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'currentH1BEmployer',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                
                              </div>
                            </div>
                            <div class="vx-col w-full mt-5 mb-5" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'h1bEmployerDocuments'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Copy of the entire H1B Petition<em v-if="beneficiaryInfo.prevEmploymentInfo.h1bEmployerDocuments">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'h1bEmployerDocuments'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'h1bEmployerDocuments'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'h1bEmployerDocuments'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.h1bEmployerDocuments"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'h1bEmployerDocuments',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobTitle'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Job Title<em v-if="beneficiaryInfo.prevEmploymentInfo.jobTitle">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobTitle'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.jobTitle"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobTitle',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <vs-input
                                  type="text"
                                  name="jobTitle"
                                  class="w-full no-icon-border"
                                  placeHolder="Job Title"
                                />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'businessType'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Employer Business E.g., IT<em v-if="beneficiaryInfo.prevEmploymentInfo.businessType">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'businessType'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.businessType"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'businessType',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <vs-input
                                  type="text"
                                  name="employerBusiness"
                                  class="w-full no-icon-border"
                                  placeHolder="Employer Business E.g., IT"
                                />
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'salary'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Salary<em v-if="beneficiaryInfo.prevEmploymentInfo.salary">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'salary'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.salary"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'salary',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mb-10" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'payFrequency'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label for class="form_label">Pay Frequency<em v-if="beneficiaryInfo.prevEmploymentInfo.payFrequency">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'payFrequency'})">
                                        <vs-checkbox
                                      
                                        v-model="beneficiaryInfo.prevEmploymentInfo.payFrequency"
                                    @change="
                                      selectCheck({
                                        section: 'beneficiaryInfo.prevEmploymentInfo',
                                        key: 'payFrequency',
                                      })
                                    "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                                  
                                </div>
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'workPhoneNumber'})">
                              <div class="form_group ph_number">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Work Phone Number<em v-if="beneficiaryInfo.prevEmploymentInfo.workPhoneNumber">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'workPhoneNumber'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'workPhoneNumber'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'workPhoneNumber'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.workPhoneNumber"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'workPhoneNumber',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <div class="vs-component">
                                  <VuePhoneNumberInput
                                    icon-pack="feather"
                                    class="w-full no-icon-border"
                                    :no-example="false"
                                    key="phone"
                                    data-vv-as="Work Phone Number"
                                    name="phone"
                                    placeholder="Work Phone Number"
                                    :no-country-selector="false"
                                    :preferred-countries="['US', 'IN']"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'fax'})">
                              <div class="form_group ph_number">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Fax Number<em v-if="beneficiaryInfo.prevEmploymentInfo.fax">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'fax'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'fax'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'fax'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.fax"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'fax',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <div class="vs-component">
                                  <VuePhoneNumberInput
                                    icon-pack="feather"
                                    class="w-full no-icon-border"
                                    :no-example="false"
                                    key="phone"
                                    data-vv-as="Fax Number"
                                    name="phone"
                                    placeholder="Fax Number"
                                    :no-country-selector="false"
                                    :preferred-countries="['US', 'IN']"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'hoursWorkedPerWeek'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Work Hours per Week<em v-if="beneficiaryInfo.prevEmploymentInfo.hoursWorkedPerWeek">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'hoursWorkedPerWeek'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'hoursWorkedPerWeek'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'hoursWorkedPerWeek'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.hoursWorkedPerWeek"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'hoursWorkedPerWeek',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <vs-input
                                  type="text"
                                  name="workHoursperWeek"
                                  class="w-full no-icon-border"
                                  placeHolder="Work Hours per Week"
                                />
                              </div>
                            </div>
                            <div class="vx-col w-full mb-6" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobDuties'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Description of Duties Performed <em v-if="beneficiaryInfo.prevEmploymentInfo.jobDuties">*</em>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Please fill in your Job Duties only.Avoid
                                          inserting all project details.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'jobDuties'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.jobDuties"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'jobDuties',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <!-- <vs-textarea class="w-full" :data-vv-as="'Description'" /> -->
                                <ckeditor  class="w-full" :data-vv-as="'Description'"  :editor="editor" :config="editorConfig"></ckeditor>

                              </div>
                            </div>

                            <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'startDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Start Date<em v-if="beneficiaryInfo.prevEmploymentInfo.startDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'startDate'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.startDate"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'startDate',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                                </Datepicker>
                              </div>
                            </div>

                            <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'endDate'})">
                              <div class="form_group mt-datepicker-wrap">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">End Date<em v-if="beneficiaryInfo.prevEmploymentInfo.endDate">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'endDate'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.endDate"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'endDate',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <Datepicker format="MM/DD/YYYY" placeholder="MM/DD/YYYY">
                                </Datepicker>
                              </div>
                            </div>
                            <div class="vx-col md:w-1/2 w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo.supervisor',key: 'name'})">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Supervisor Name<em v-if="beneficiaryInfo.prevEmploymentInfo.supervisor.name">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'name'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'name'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'name'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.supervisor.name"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo.supervisor',key: 'name',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <vs-input
                                  type="text"
                                  name="supervisorName"
                                  class="w-full no-icon-border"
                                  placeHolder="Supervisor Name"
                                />
                              </div>
                            </div>
                            <div class="vx-col w-1/2" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo.supervisor',key: 'phoneNumber'})">
                              <div class="form_group ph_number">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label"
                                    >Supervisor Phone Number<em v-if="beneficiaryInfo.prevEmploymentInfo.phoneNumber">*</em></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'phoneNumber'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'phoneNumber'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo.supervisor',key:'phoneNumber'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.supervisor.phoneNumber"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo.supervisor',key: 'phoneNumber',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <div class="vs-component">
                                  <VuePhoneNumberInput
                                    icon-pack="feather"
                                    class="w-full no-icon-border"
                                    :no-example="false"
                                    key="phone"
                                    data-vv-as="Supervisor Phone Number"
                                    name="phone"
                                    placeholder="Supervisor Phone Number"
                                    :no-country-selector="false"
                                    :preferred-countries="['US', 'IN']"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-full" v-if="showOrHideField({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'address'})">
                              <div>
                                <h3 class="small-header">
                                  Work Address<em v-if="beneficiaryInfo.prevEmploymentInfo.address">*</em>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'beneficiaryInfo.prevEmploymentInfo',key:'address'})">
                                          <vs-checkbox
                                        
                                          v-model="beneficiaryInfo.prevEmploymentInfo.address"
                                          @change="selectCheck({section: 'beneficiaryInfo.prevEmploymentInfo',key: 'address',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                 
                                </h3>
                                <div class="vx-row">
                                  <div class="vx-col md:w-1/2 w-1/2">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Street Address</label>
                                      </div>
                                      <vs-input
                                        class="w-full"
                                        v-validate="'required'"
                                        data-vv-as="Street Address"
                                      />
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label class="form_label">Apt, Suite</label>
                                      </div>
                                      <div class="address-suite">
                                        <ul
                                          class="demo-alignment custom-radio"
                                          vs-type="flex"
                                          vs-align="center"
                                        >
                                          <li>
                                            <vs-checkbox name="aptType1">Apt</vs-checkbox>
                                          </li>
                                          <li>
                                            <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                          </li>
                                          <li>
                                            <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                          </li>
                                        </ul>
                                        <vs-input class="" data-vv-as="Apt, Suite" />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label"> Country</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select Country"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label"> State</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select State"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="con-select w-full select-large">
                                        <div class="d-flex align-end mb-1">
                                          <label class="form_label"> City</label>
                                        </div>
                                        <multiselect
                                          name="Status"
                                          :multiple="false"
                                          :options="[]"
                                          :hideSelected="true"
                                          :close-on-select="true"
                                          :clear-on-select="false"
                                          :preserve-search="true"
                                          placeholder="Select City"
                                          :preselect-first="false"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="vx-col md:w-1/2 w-full">
                                    <div class="form_group">
                                      <div class="d-flex align-end mb-1">
                                        <label for class="form_label">Zip Code</label>
                                      </div>
                                      <vs-input class="w-full" />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="m-auto"
                                  vs-type="flex"
                                  vs-align="center"
                                  vs-lg="2"
                                  vs-sm="2"
                                >
                                  <a
                                    class="add-more ml-0 mb-10"
                                    style="display: inline-block"
                                    type="filled"
                                  >
                                    <span>+</span> Add Another Employer
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <!-- documents-->
            <div v-if="currentTab=='Documents Info'">
              <form data-vv-scope="documentsform" @submit.prevent="" @keydown.enter.prevent="">
                <vs-col class="w-full p-0">
                  <vs-alert
                    color="warning"
                    class="warning-alert top-warning-alert"
                    icon-pack="IntakePortal"
                    icon="IP-information-button"
                    active="true"
                  >
                    NOTE: This questionnaire should be filled out completely and
                    accurately. Kindly read the instructions carefully.
                  </vs-alert>
                </vs-col>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                  <div class="form-container pt-10 form-container_QT">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <h3 class="small-header">
                          List of documents needs to be updated
                          <span class="file-type">
                            (File Type: PDF, DOC, JPEG, PNG. Max file size: 200MB)
                          </span>
                        </h3>
                        <div class="documents_group case_documents">

                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgAckOfPrevLaborApplications'})">
                              <div class="vx-col w-full">
                                <div class="form_group">
                                  <div class="d-flex align-end mb-1">
                                    <label class="form_label">{{'slgAckOfPrevLaborApplications' | formatdoctype}}<em
                                        v-if="documents.slgAckOfPrevLaborApplications">*</em></label>
                                    <div class="check_box_container" v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgAckOfPrevLaborApplications'})">
                                        <span class="custom_checkbox"
                                          :class="{'checked':checkFieldRequired({section:'documents',key:'slgAckOfPrevLaborApplications'})}">
                                          <span class="checkmark">
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgAckOfPrevLaborApplications'})">
                                        <vs-checkbox v-model="documents.slgAckOfPrevLaborApplications"
                                          @change="selectCheck({section: 'documents',key: 'slgAckOfPrevLaborApplications',})"></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <file-upload :hideSelected="true" class="file-upload-input file-upload-input-cs" :wrapclass="'md:w-full'">
                                    <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                    Upload
                                  </file-upload>
                                </div>
                              </div>
                            </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgPrevLaborApplications'})">
                          <div class="vx-col w-full">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">{{'slgPrevLaborApplications' | formatdoctype }}<em
                                    v-if="documents.slgPrevLaborApplications">*</em></label>
                                <div class="check_box_container" v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPrevLaborApplications'})">
                                    <span class="custom_checkbox"
                                      :class="{'checked':checkFieldRequired({section:'documents',key:'slgPrevLaborApplications'})}">
                                      <span class="checkmark">
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPrevLaborApplications'})">
                                    <vs-checkbox v-model="documents.slgPrevLaborApplications"
                                      @change="selectCheck({section: 'documents',key: 'slgPrevLaborApplications',})"></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <file-upload :hideSelected="true" class="file-upload-input file-upload-input-cs" :wrapclass="'md:w-full'">
                                <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                                Upload
                              </file-upload>
                            </div>
                          </div>
                        </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'resume'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Resume<em v-if="documents.resume">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'resume'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'resume'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'resume'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.resume"
                                          @change="selectCheck({section: 'documents',key: 'resume',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'expLetters'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Experience Letters<em v-if="documents.expLetters">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'expLetters'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'expLetters'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'expLetters'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.expLetters"
                                          @change="selectCheck({section: 'documents',key: 'expLetters',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'passportVisaI94'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Passport- First page with photo, Visa page and last page with address<em v-if="documents.passportVisaI94">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'passportVisaI94'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'passportVisaI94'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'passportVisaI94'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.passportVisaI94"
                                          @change="selectCheck({section: 'documents',key: 'passportVisaI94',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgResume'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">Latest Resume<em v-if="documents.slgResume">*</em></label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgResume'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgResume'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgResume'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgResume"
                                          @change="selectCheck({section: 'documents',key: 'slgResume',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgEduCredentials'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Educational Documents<em v-if="documents.slgEduCredentials">*</em></span>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Degree certificates, transcripts/marksheets, and
                                          any training certificates.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgEduCredentials'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgEduCredentials'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgEduCredentials'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgEduCredentials"
                                          @change="selectCheck({section: 'documents',key: 'slgEduCredentials',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgEvalOfEduCredentials'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Copy of Educational Evaluation, if any (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.) <em v-if="documents.slgEvalOfEduCredentials">*</em></span></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgEvalOfEduCredentials'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgEvalOfEduCredentials'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgEvalOfEduCredentials'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgEvalOfEduCredentials"
                                          @change="selectCheck({section: 'documents',key: 'slgEvalOfEduCredentials',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgExpLetters'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span
                                      >Experience Letters/Employment Confirmation Letters
                                      from all previous employers<em v-if="documents.slgExpLetters">*</em>
                                    </span>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          The letters must be printed on the company’s
                                          letterhead. The letters should include details
                                          of the job duties performed, the skills
                                          utilized, start and end dates of employment, and
                                          position(s) held and must be duly signed and
                                          dated by an authorized representative of the
                                          company.
                                        </p>
                                      </div>
                                    </div>
                                  </label>
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgExpLetters'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgExpLetters'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgExpLetters'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgExpLetters"
                                          @change="selectCheck({section: 'documents',key: 'slgExpLetters',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                 
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgPassportAndVisa'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Clear copy of passport <em v-if="documents.slgPassportAndVisa">*</em> </span>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>All pages except blank ones.</p>
                                      </div>
                                    </div></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPassportAndVisa'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPassportAndVisa'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPassportAndVisa'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgPassportAndVisa"
                                          @change="selectCheck({section: 'documents',key: 'slgPassportAndVisa',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgI94'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Current I-94 <em v-if="documents.slgI94">*</em></span></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgI94'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgI94'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgI94'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgI94"
                                          @change="selectCheck({section: 'documents',key: 'slgI94',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                 
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgCurPrevH1BH4ApprovalsByINS'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Copies of all approvals <em v-if="documents.slgCurPrevH1BH4ApprovalsByINS">*</em> </span>
                                    <div class="IB_tooltip">
                                      <span
                                        ><info-icon
                                          size="1.5x"
                                          class="custom-class"
                                        ></info-icon
                                      ></span>
                                      <div class="tooltip_cnt">
                                        <p>
                                          Copies of all approvals you have received so
                                          far, including H-1B, H-4, B-1/B-2, F-1/F-2,
                                          L-1/L-2, I-20’s, CPT/OPT cards, I-140, as
                                          applicable.
                                        </p>
                                      </div>
                                    </div></label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgCurPrevH1BH4ApprovalsByINS'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgCurPrevH1BH4ApprovalsByINS'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgCurPrevH1BH4ApprovalsByINS'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgCurPrevH1BH4ApprovalsByINS"
                                          @change="selectCheck({section: 'documents',key: 'slgCurPrevH1BH4ApprovalsByINS',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgTransScripts'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Transcripts<em v-if="documents.slgTransScripts">*</em> </span>
                                    </label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgTransScripts'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgTransScripts'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgTransScripts'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgTransScripts"
                                          @change="selectCheck({section: 'documents',key: 'slgTransScripts',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                          <div class="vx-row delete-row" v-if="showOrHideField({section: 'documents',key: 'slgPrevNonimmApprovalNotices'})">
                            <div class="vx-col w-full">
                              <div class="form_group">
                                <div class="d-flex align-end mb-1">
                                  <label class="form_label">
                                    <span>Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 and etc….) Please include a copy of your current H-1 petition, and H-1 support letter, that provides your current job description <em v-if="documents.slgPrevNonimmApprovalNotices">*</em> </span>
                                    </label
                                  >
                                  <div class="check_box_container"  v-if="isEdit">
                                        <div class="check_box_list" @click="toogleFields({section:'documents',key:'slgPrevNonimmApprovalNotices'})">
                                          <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'documents',key:'slgPrevNonimmApprovalNotices'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                          </span>
                                          <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                          </div>
                                        </div>
                                        <div class="check_box_list" v-if="checkFieldRequired({section:'documents',key:'slgPrevNonimmApprovalNotices'})">
                                          <vs-checkbox
                                        
                                          v-model="documents.slgPrevNonimmApprovalNotices"
                                          @change="selectCheck({section: 'documents',key: 'slgPrevNonimmApprovalNotices',})"
                                          ></vs-checkbox>
                                          <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                          </div>
                                        </div>
                                        </div>
                                  
                                </div>
                                <file-upload
                                  :hideSelected="true"
                                  class="file-upload-input file-upload-input-cs"
                                  :wrapclass="'md:w-full'"
                                >
                                  <img
                                    class="file-icon"
                                    src="@/assets/images/main/file-upload.svg"
                                  />
                                  Upload
                                </file-upload>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-col>
              </form>
            </div>
            <div v-if="currentTab=='Dependents Info'">
              <form
                data-vv-scope="dependentsform"
                @submit.prevent=""
                @keydown.enter.prevent=""
              >
              <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'hasSpouse'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you want to fill spouse information?<em v-if="dependentsInfo.spouse.hasSpouse">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'hasSpouse'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'hasSpouse'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'hasSpouse'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.spouse.hasSpouse"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.spouse',
                                              key: 'hasSpouse',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                </div>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                  <div class="vx-row">
                    <div class="vx-col w-full" >
                      <h3  class="small-header">Spouse Information</h3>
                    </div>
                    <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="dependentsInfo.spouse.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.spouse.gender"
                             @change="
                             selectCheck({ section: 'dependentsInfo.spouse', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                    </div>
                    <div class="divider full-divider mb-10"></div>
                    <div class="vx-col w-full mb-10">
                      <div class="vx-input-group flex form-input-group FML">
                        <div class="vx-input-group-default flex-grow">
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'firstName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">First Name<em v-if="dependentsInfo.spouse.firstName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'firstName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'firstName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.firstName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',

                                      key: 'firstName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'middleName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Middle Name<em v-if="dependentsInfo.spouse.middleName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'middleName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'middleName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.middleName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',

                                      key: 'middleName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'lastName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Last Name<em v-if="dependentsInfo.spouse.lastName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'lastName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'lastName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.lastName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.spouse',

                                      key: 'lastName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'email'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Email<em v-if="dependentsInfo.spouse.email">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'email'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'email'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.spouse.email"
                             @change="
                               selectCheck({ section: 'dependentsInfo.spouse', key: 'email' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name (if any)<em v-if="dependentsInfo.spouse.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.spouse.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'phoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.spouse.phoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.spouse',

                                        key: 'phoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'cellPhoneNumber'}) && false">
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Phone Number<em v-if="dependentsInfo.spouse.cellPhoneNumber">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'cellPhoneNumber'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'cellPhoneNumber'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'cellPhoneNumber'})">
                            <vs-checkbox
                          
                            v-model="dependentsInfo.spouse.cellPhoneNumber"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'cellPhoneNumber',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="vs-component">
                          <VuePhoneNumberInput
                            icon-pack="feather"
                            class="w-full no-icon-border"
                            :no-example="false"
                            key="phone"
                            data-vv-as="Phone Number"
                            name="phone"
                            placeholder="Phone Number"
                            :preferred-countries="['US', 'IN']"
                            :disabled="true"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'dateOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Date of Birth<em v-if="dependentsInfo.spouse.dateOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})}"  >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'dateOfBirth'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.dateOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'dateOfBirth',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.spouse.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'provinceOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Province of Birth<em v-if="dependentsInfo.spouse.provinceOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'provinceOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.provinceOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'provinceOfBirth',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'locationOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Location of Birth<em v-if="dependentsInfo.spouse.locationOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'locationOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.locationOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'locationOfBirth',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Citizenship<em v-if="dependentsInfo.spouse.countryOfCitizenship">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'countryOfCitizenship'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'countryOfCitizenship',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'otherCountriesOfCitizenship'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Any other country(ies) of Citizenship<em v-if="dependentsInfo.spouse.otherCountriesOfCitizenship">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'otherCountriesOfCitizenship'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'otherCountriesOfCitizenship'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'otherCountriesOfCitizenship'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.otherCountriesOfCitizenship"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'otherCountriesOfCitizenship',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Visa status<em v-if="dependentsInfo.spouse.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'currentStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'currentStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.spouse.currentStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.spouse',
                                  key: 'currentStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'statusExpiryDate'})">
                      <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.spouse.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.spouse',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Status Expiration Date<em v-if="dependentsInfo.spouse.statusExpiryDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})}"  >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'statusExpiryDate'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.statusExpiryDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'statusExpiryDate',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportNumber'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Number<em v-if="dependentsInfo.spouse.passportNumber">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportNumber'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.passportNumber"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'passportNumber',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.spouse.passportIssuedDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.passportIssuedDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'passportIssuedDate',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportExpiryDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.spouse.passportExpiryDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportExpiryDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.spouse.passportExpiryDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',

                                key: 'passportExpiryDate',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'passportIssuedCountry'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"
                            >Country of Passport Issued<em v-if="dependentsInfo.spouse.passportIssuedCountry">*</em></label
                          >
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'passportIssuedCountry'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.passportIssuedCountry"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.spouse',
                                key: 'passportIssuedCountry',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-10" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'SSN'})">
                      <div class="vx-row">
                        <div class="vx-col  w-full mb-5">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"
                                >SSN number<em v-if="dependentsInfo.spouse.SSN">*</em></label
                              >
                              <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.spouse',key:'SSN'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'SSN'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.SSN"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.spouse',
                                    key: 'SSN',
                                  })
                                "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                              
                            </div>
                            <div class="vs-con-input">
                              <input
                                type="text"
                                name="0"
                                placeholder="123 - 45 - 6789"
                                data-vv-as="123 - 45 - 6789"
                                class="vs-inputx vs-input--input normal"
                              />
                            </div>
                          </div>
                        </div>
                      
                      </div>
                    </div>
                    <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.spouse',key: 'addressOutsideUS'})">
                      <h3 class="small-header">
                        Foreign Address <em v-if="dependentsInfo.spouse.addressOutsideUS">*</em>
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.spouse',key:'addressOutsideUS'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.spouse.addressOutsideUS"
                          @change="
                            selectCheck({ section: 'dependentsInfo.spouse', key: 'addressOutsideUS' })
                          "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                        
                      </h3>
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Street Address</label>
                            </div>
                            <vs-input
                              class="w-full"
                              v-validate="'required'"
                              data-vv-as="Street Address"
                            />
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Apt, Suite</label>
                            </div>
                            <div class="address-suite">
                              <ul
                                class="demo-alignment custom-radio"
                                vs-type="flex"
                                vs-align="center"
                              >
                                <li>
                                  <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                </li>
                              </ul>
                              <vs-input class="" data-vv-as="Apt, Suite" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Country</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select Country"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> State</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select State"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> City</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select City"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label for class="form_label">Zip Code</label>
                            </div>
                            <vs-input class="w-full" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>
              </form>
            </div>
            <div v-if="currentTab=='Dependents Info'">
              <form
                data-vv-scope="dependentsform"
                @submit.prevent=""
                @keydown.enter.prevent=""
              >
              <div class="vx-col w-full mb-0 mt-5" style="padding-left:50px" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'hasChildren'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Do you want to fill children information?<em v-if="dependentsInfo.childrens.hasChildren">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                      <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                        <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})}" >
                                          <span class="checkmark" >
                                            <i class="material-icons">check</i>
                                          </span>
                                        </span>
                                        <div class="tooltip_cnt">
                                          <p>Field is required</p>
                                        </div>
                                      </div>
                                      <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'hasChildren'})">
                                        <vs-checkbox
                                      
                                        v-model="dependentsInfo.childrens.hasChildren"
                                          @change="
                                            selectCheck({
                                              section: 'dependentsInfo.childrens',
                                              key: 'hasChildren',
                                            })
                                          "
                                        ></vs-checkbox>
                                        <div class="tooltip_cnt">
                                          <p>Validation is required</p>
                                        </div>
                                      </div>
                                      </div>
                            
                          </div>
                          <div class="form_radio_btns">
                            <vs-button class="yes mr-5" color="success" type="border">
                              Yes</vs-button
                            >
                            <vs-button class="no" color="danger" type="border"
                              >No</vs-button
                            >
                          </div>
                        </div>
                </div>
                <vs-col
                  class="m-auto float-none"
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                >
                <div class="form-container pt-10 questionnaire_hb form-container_QT">
                  <div class="vx-row">
                    <div class="vx-col w-full" >
                      <h3  class="small-header">Child Information</h3>
                    </div>
                    <div class="vx-col w-full mb-10 beneficiary-info-btns" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'gender'})">
                       <div class="d-flex align-end mb-1">
                         <label class="form_label">Gender<em v-if="dependentsInfo.childrens.gender">*</em></label>
                         <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'gender'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'gender'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'gender'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.childrens.gender"
                             @change="
                             selectCheck({ section: 'dependentsInfo.childrens', key: 'gender' })
                           "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                       </div>
                       <vx-input-group class="form-input-group FML">
                         <vs-button
                           class="btn male-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Male</vs-button
                         >
                         <vs-button
                           class="btn female-btn"
                           icon-pack="IntakePortal"
                           icon=" IP-femenine-1"
                           type="border"
                           :disabled="true"
                           >Female</vs-button
                         >
                         <vs-button
                           class="btn others-btn"
                           icon-pack="feather"
                           icon="icon-circle"
                           type="border"
                           :disabled="true"
                           >Others</vs-button
                         >
                       </vx-input-group>
                    </div>
                    <div class="divider full-divider mb-10"></div>
                    <div class="vx-col w-full mb-10">
                      <div class="vx-input-group flex form-input-group FML">
                        <div class="vx-input-group-default flex-grow">
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'firstName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">First Name<em v-if="dependentsInfo.childrens.firstName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'firstName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'firstName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.firstName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',

                                      key: 'firstName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'middleName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Middle Name<em v-if="dependentsInfo.childrens.middleName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'middleName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'middleName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.middleName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',

                                      key: 'middleName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'lastName'})">
                            <div class="form_group">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Last Name<em v-if="dependentsInfo.childrens.lastName">*</em></label>
                                <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'lastName'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'lastName'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.lastName"
                                  @change="
                                    selectCheck({
                                      section: 'dependentsInfo.childrens',

                                      key: 'lastName',
                                    })
                                  "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                                
                              </div>
                              <div class="vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                  <input
                                    type="text"
                                    maxlength="200"
                                    class="vs-inputx vs-input--input normal"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'email'})">
                       <div class="form_group">
                         <div class="d-flex align-end mb-1">
                           <label class="form_label">Email<em v-if="dependentsInfo.childrens.email">*</em></label>
                           <div class="check_box_container"  v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'email'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})}" >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'email'})">
                             <vs-checkbox
                            
                             v-model="dependentsInfo.childrens.email"
                             @change="
                               selectCheck({ section: 'dependentsInfo.childrens', key: 'email' })
                             "
                             ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                           </div>
                         </div>
                         <div class="vs-con-input">
                           <input
                             type="text"
                             maxlength="200"
                             class="vs-inputx vs-input--input normal" :disabled="true"
                           />
                         </div>
                       </div>
                     </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'maidenName'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Maiden Name (if any)<em v-if="dependentsInfo.childrens.maidenName">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'maidenName'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'maidenName'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'maidenName'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.maidenName"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'maidenName',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="vs-con-input">
                            <input type="text" class="vs-inputx vs-input--input normal" />
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'phoneNumber'})">
                        <div class="form_group">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Phone Number<em v-if="dependentsInfo.childrens.phoneNumber">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                                  <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                                    <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})}" >
                                      <span class="checkmark" >
                                        <i class="material-icons">check</i>
                                      </span>
                                    </span>
                                    <div class="tooltip_cnt">
                                      <p>Field is required</p>
                                    </div>
                                  </div>
                                  <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'phoneNumber'})">
                                    <vs-checkbox
                                  
                                    v-model="dependentsInfo.childrens.phoneNumber"
                                    @change="
                                      selectCheck({
                                        section: 'dependentsInfo.childrens',

                                        key: 'phoneNumber',
                                      })
                                    "
                                    ></vs-checkbox>
                                    <div class="tooltip_cnt">
                                      <p>Validation is required</p>
                                    </div>
                                  </div>
                                  </div>
                            
                          </div>
                          <div class="vs-component">
                            <VuePhoneNumberInput
                              icon-pack="feather"
                              class="w-full no-icon-border"
                              :no-example="false"
                              key="phone"
                              data-vv-as="Phone Number"
                              name="phone"
                              placeholder="Phone Number"
                              :preferred-countries="['US', 'IN']"
                            />
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-5" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'cellPhoneNumber'})">
                      <div class="form_group">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Phone Number<em v-if="dependentsInfo.childrens.cellPhoneNumber">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'cellPhoneNumber'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'cellPhoneNumber'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'cellPhoneNumber'})">
                            <vs-checkbox
                          
                            v-model="dependentsInfo.childrens.cellPhoneNumber"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',
                                key: 'cellPhoneNumber',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="vs-component">
                          <VuePhoneNumberInput
                            icon-pack="feather"
                            class="w-full no-icon-border"
                            :no-example="false"
                            key="phone"
                            data-vv-as="Phone Number"
                            name="phone"
                            placeholder="Phone Number"
                            :preferred-countries="['US', 'IN']"
                            :disabled="true"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'dateOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Date of Birth<em v-if="dependentsInfo.childrens.dateOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})}"  >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'dateOfBirth'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.dateOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',
                                key: 'dateOfBirth',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfBirth'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Birth<em v-if="dependentsInfo.childrens.countryOfBirth">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfBirth'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.countryOfBirth"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'countryOfBirth',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'provinceOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Province of Birth<em v-if="dependentsInfo.childrens.provinceOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'provinceOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.provinceOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'provinceOfBirth',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'locationOfBirth'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Location of Birth<em v-if="dependentsInfo.childrens.locationOfBirth">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'locationOfBirth'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.locationOfBirth"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'locationOfBirth',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'countryOfCitizenship'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Country of Citizenship<em v-if="dependentsInfo.childrens.countryOfCitizenship">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'countryOfCitizenship'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.countryOfCitizenship"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'countryOfCitizenship',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'otherCountriesOfCitizenship'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Any other country(ies) of Citizenship<em v-if="dependentsInfo.childrens.otherCountriesOfCitizenship">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'otherCountriesOfCitizenship'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'otherCountriesOfCitizenship'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'otherCountriesOfCitizenship'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.otherCountriesOfCitizenship"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',
                                key: 'otherCountriesOfCitizenship',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'currentStatus'})">
                        <div class="form_group mt-datepicker-wrap">
                          <div class="d-flex align-end mb-1">
                            <label class="form_label">Current Visa status<em v-if="dependentsInfo.childrens.currentStatus">*</em></label>
                            <div class="check_box_container"  v-if="isEdit">
                            <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'currentStatus'})">
                              <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})}" >
                                <span class="checkmark" >
                                  <i class="material-icons">check</i>
                                </span>
                              </span>
                              <div class="tooltip_cnt">
                                <p>Field is required</p>
                              </div>
                            </div>
                            <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'currentStatus'})">
                              <vs-checkbox
                             
                              v-model="dependentsInfo.childrens.currentStatus"
                              @change="
                                selectCheck({
                                  section: 'dependentsInfo.childrens',
                                  key: 'currentStatus',
                                })
                              "
                              ></vs-checkbox>
                              <div class="tooltip_cnt">
                                <p>Validation is required</p>
                              </div>
                            </div>
                            </div>
                            
                          </div>
                          <div class="con-select w-full">
                            <multiselect :options="[]" placeholder="Select">
                            </multiselect>
                          </div>
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 relative" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'statusExpiryDate'})">
                      <div class="vx-col w-full md:w-1/2 ds_check marr10" style="z-index:9999" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'isDSExpiryDate'})">
                       <div class="">
                         <div class="form_group con-vs-checkbox custom-form-label custom-cx-box">
                         <vs-checkbox :disabled="true">If D/S check here</vs-checkbox>
                         </div>
                         <div class="check_box_container" v-if="isEdit">
                           <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})}"  >
                               <span class="checkmark" >
                                 <i class="material-icons">check</i>
                               </span>
                             </span>
                             <div class="tooltip_cnt">
                               <p>Field is required</p>
                             </div>
                           </div>
                           <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'isDSExpiryDate'})">
                             <vs-checkbox
                               
                                 v-model="dependentsInfo.childrens.isDSExpiryDate"
                                 @change="
                                   selectCheck({
                                     section: 'dependentsInfo.childrens',
                                     key: 'isDSExpiryDate',
                                   })
                                 "
                               ></vs-checkbox>
                             <div class="tooltip_cnt">
                               <p>Validation is required</p>
                             </div>
                           </div>
                         </div>
                       </div>
                      </div>
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Status Expiration Date<em v-if="dependentsInfo.childrens.statusExpiryDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})}"  >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'statusExpiryDate'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.statusExpiryDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',
                                key: 'statusExpiryDate',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full" >
                        <div class="form_group w-full">
                          <label class="form_label"
                            ><h3 class="small-header">Passport</h3></label
                          >
                        </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportNumber'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Number<em v-if="dependentsInfo.childrens.passportNumber">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportNumber'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.passportNumber"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'passportNumber',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div class="vs-con-input">
                          <input type="text" class="vs-inputx vs-input--input normal" />
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Issued Date<em v-if="dependentsInfo.childrens.passportIssuedDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.passportIssuedDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'passportIssuedDate',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportExpiryDate'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label">Passport Expiry Date<em v-if="dependentsInfo.childrens.passportExpiryDate">*</em></label>
                          <div class="check_box_container"  v-if="isEdit">
                                <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                  <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})}" >
                                    <span class="checkmark" >
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <div class="tooltip_cnt">
                                    <p>Field is required</p>
                                  </div>
                                </div>
                                <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportExpiryDate'})">
                                  <vs-checkbox
                                
                                  v-model="dependentsInfo.childrens.passportExpiryDate"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',

                                key: 'passportExpiryDate',
                              })
                            "
                                  ></vs-checkbox>
                                  <div class="tooltip_cnt">
                                    <p>Validation is required</p>
                                  </div>
                                </div>
                                </div>
                          
                        </div>
                        <div
                          class="mx-datepicker pad5"
                          typeable="true"
                          name="dfdateOfBirth"
                          data-vv-as="Date of Birth"
                        >
                          <div class="vs-con-input">
                            <Datepicker
                              format="MM/DD/YYYY"
                              placeholder="MM/DD/YYYY"
                            ></Datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'passportIssuedCountry'})">
                      <div class="form_group mt-datepicker-wrap">
                        <div class="d-flex align-end mb-1">
                          <label class="form_label"
                            >Country of Passport Issued<em v-if="dependentsInfo.childrens.passportIssuedCountry">*</em></label
                          >
                          <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'passportIssuedCountry'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.passportIssuedCountry"
                            @change="
                              selectCheck({
                                section: 'dependentsInfo.childrens',
                                key: 'passportIssuedCountry',
                              })
                            "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                          
                        </div>
                        <div class="con-select w-full">
                          <multiselect :options="[]" placeholder="Select">
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="vx-col w-full md:w-1/2 mb-10" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'SSN'})">
                      <div class="vx-row">
                        <div class="vx-col  w-full mb-5">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label"
                                >SSN number<em v-if="dependentsInfo.childrens.SSN">*</em></label
                              >
                              <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list" @click="toogleFields({section:'dependentsInfo.childrens',key:'SSN'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'SSN'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.SSN"
                                @change="
                                  selectCheck({
                                    section: 'dependentsInfo.childrens',
                                    key: 'SSN',
                                  })
                                "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                              
                            </div>
                            <div class="vs-con-input">
                              <input
                                type="text"
                                name="0"
                                placeholder="123 - 45 - 6789"
                                data-vv-as="123 - 45 - 6789"
                                class="vs-inputx vs-input--input normal"
                              />
                            </div>
                          </div>
                        </div>
                      
                      </div>
                    </div>
                    <div class="vx-col w-full" v-if="showOrHideField({section: 'dependentsInfo.childrens',key: 'addressOutsideUS'})">
                      <h3 class="small-header">
                        Foreign Address <em v-if="dependentsInfo.childrens.addressOutsideUS">*</em>
                        <div class="check_box_container"  v-if="isEdit">
                          <div class="check_box_list"  @click="toogleFields({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                            <span class="custom_checkbox" :class="{'checked':checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})}" >
                              <span class="checkmark" >
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <div class="tooltip_cnt">
                              <p>Field is required</p>
                            </div>
                          </div>
                          <div class="check_box_list" v-if="checkFieldRequired({section:'dependentsInfo.childrens',key:'addressOutsideUS'})">
                            <vs-checkbox
                            
                            v-model="dependentsInfo.childrens.addressOutsideUS"
                          @change="
                            selectCheck({ section: 'dependentsInfo.childrens', key: 'addressOutsideUS' })
                          "
                            ></vs-checkbox>
                            <div class="tooltip_cnt">
                              <p>Validation is required</p>
                            </div>
                          </div>
                          </div>
                        
                      </h3>
                      <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Street Address</label>
                            </div>
                            <vs-input
                              class="w-full"
                              v-validate="'required'"
                              data-vv-as="Street Address"
                            />
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label class="form_label">Apt, Suite</label>
                            </div>
                            <div class="address-suite">
                              <ul
                                class="demo-alignment custom-radio"
                                vs-type="flex"
                                vs-align="center"
                              >
                                <li>
                                  <vs-checkbox  name="aptType1">Apt</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType2">Ste</vs-checkbox>
                                </li>
                                <li>
                                  <vs-checkbox name="aptType3">Flr</vs-checkbox>
                                </li>
                              </ul>
                              <vs-input class="" data-vv-as="Apt, Suite" />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label">Country</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select Country"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> State</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select State"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="con-select w-full select-large">
                              <div class="d-flex align-end mb-1">
                                <label class="form_label"> City</label>
                              </div>
                              <multiselect
                                name="Status"
                                :multiple="false"
                                :options="[]"
                                :hideSelected="true"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Select City"
                                :preselect-first="false"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                          <div class="form_group">
                            <div class="d-flex align-end mb-1">
                              <label for class="form_label">Zip Code</label>
                            </div>
                            <vs-input class="w-full" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </vs-col>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-collapse accordion> </vs-collapse>

    <vs-popup
      class="holamundo success-popups"
      title="Your registration is complete."
      :active.sync="SuccessQuestionnaire"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire submitted successfully!</h2>
      <p>
        It will be reviewed by the petitioner and appropriate actions will be taken soon.
      </p>
    </vs-popup>

    <vs-popup
      class="holamundo success-popups"
      title="Template configuration complete."
      :active.sync="showFinalsubmitPopup"
    >
      <figure>
        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
      </figure>
      <h2 class="title">Questionnaire template submission!</h2>
      <p>Are you sure to continue?</p>
      <div class="popup-footer">
        <vs-button
          color="dark"
          class="cancel"
          type="filled"
          @click="showFinalsubmitPopup = false"
          >Cancel</vs-button
        >
        <vs-button color="success" class="save ml-3" type="filled" @click="saveMe(true)"
          >Yes</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import Datepicker from "vuejs-datepicker-inv";
import FileUpload from "vue-upload-component/src";

import { InfoIcon } from "vue-feather-icons";
import { EyeIcon } from "vue-feather-icons";
import { Trash2Icon } from "vue-feather-icons";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';


export default {
  props: {
    templateId: {
      default: "",
    },
    isEdit:true,
  },
  beforeDestroy() {
    this.SuccessQuestionnaire = false;
    document.removeEventListener("click", this.reloadthePage);
  },
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
     currentTab: 'PERM Application',
      tabslist: [{
                        key: "casedetails",
                        name: "Personal Info"
                    }
    
                ],
    SuccessQuestionnaire: false,
    showFinalsubmitPopup: false,
    beneficiaryInfo: {
      name: true,
      firstName: true,
      middleName: true,
      lastName: true,
      email: true,
      gender: true,
      homePhoneNumber: true,
      homePhoneCountryCode: {
        countryCode: true,
        countryCallingCode: true,
      },
      cellPhoneNumber: true,
      cellPhoneCountryCode: {
        countryCode: true,
        countryCallingCode: true,
      },
      workPhoneNumber: true,
      workPhoneCountryCode: { countryCode: true, countryCallingCode: true },
      fax: true,
      faxCountryCode: { countryCode: true, countryCallingCode: true },
      dateOfBirth: true,
      countryOfBirth: true,
      countryOfBirthDetails: true,
      provinceOfBirth: true,
      provinceOfBirthDetails: true,
      locationOfBirth: true,
      countryOfCitizenship: true,
      countryOfCitizenshipDetails: true,
      mailingAddressIsSameAsAddress: true,
      mailingAddress: {
        line1: true,
        line2: true,
        aptType: true,
        locationId: true,
        locationDetails: true,
        stateId: true,
        stateDetails: true,
        countryId: true,
        countryDetails: true,
        zipcode: true,
      },
      address: {
        line1: true,
        line2: true,
        aptType: true,
        locationId: true,
        locationDetails: true,
        stateId: true,
        stateDetails: true,
        countryId: true,
        countryDetails: true,
        zipcode: true,
      },
      currentAddress: {
        line1: true,
        line2: true,
        aptType: true,
        locationId: true,
        locationDetails: true,
        stateId: true,
        stateDetails: true,
        countryId: true,
        countryDetails: true,
        zipcode: true,
      },
      haveYouEverTravelledToUS: true,
      priorPeriodOfStayInUS: [
        {
          _id: 0,
          visaStatus: true,
          visaStatusDetails: true,
          noOfDays: true,
          enteredDate: true,
          departedDate: true,
          dateerror: true,
        },
      ],
      previouslyMarried: true,
      previousSpouse: {
            previousSpouse:true,
            firstName: true,
            middleName: true,
            lastName: true,
            dateOfBirth: true,
            dateOfMarriage: true,
            dateOfMarriageEnd: true,
            maidenName: true,
            //Place of Marriage
            countryOfMarriage: true,
            countryOfMarriageDetails: true,
            provinceOfMarriage: true,
            provinceOfMarriageDetails: true,
            locationOfMarriage: true,

            //Place of Termination
            countryOfMarriageTermination: true,
            countryOfMarriageTerminationDetails: true,
            provinceOfMarriageTermination: true,
            provinceOfMarriageTerminationDetails: true,
            locationOfMarriageTermination: true,
            obtainPermResidenceThroughSpouse: true,
            marriageEndedDueTo: true,
            marriageEndedOtherInfo: true,
          },
      curNonImmigrantVisaStatus: true,
      curNonImmigrantVisaStatusDetails: true,
      curVisaExpiryNumber: true,
      I94: true,
      I94ExpiryDate: true,
      firstEntryDateOrApprovalInUsWithH1B: true,
      dateFifthYearOfHExpire: true,
      alienNumber: true,
      SSN: true,
      educations: [
        {
          _id: 0,
          name: true,
          educations:true,
          address: {
            line1: true,
            line2: true,
            aptType: true,
            locationId: true,
            locationDetails: true,
            stateId: true,
            stateDetails: true,
            countryId: true,
            countryDetails: true,
            zipcode: true,
          },
          highestDegree: true,
          highestDegreeDetails: true,
          majorFieldOfStudy: true,
          attendedFrom: true,
          attendedTo: true,
          graduatedYear: true,
          degreereceived: true,
          isAccredited: true,
          isForProfit: true,
        },
      ],
      vacationalOrTrainingInst: [
        {
          vacationalOrTrainingInst:true,
          _id: 0,
          name: true,
          address: {
            line1: true,
            line2: true,
            aptType: true,
            locationId: true,
            locationDetails: true,
            stateId: true,
            stateDetails: true,
            countryId: true,
            countryDetails: true,
            zipcode: true,
          },
          highestDegree: true,
          highestDegreeDetails: true,
          majorFieldOfStudy: true,
          attendedFrom: true,
          attendedTo: true,
          graduatedYear: true,
          degreereceived: true,
          isAccredited: true,
          isForProfit: true,
        },
      ],
      prevEmploymentInfo: [
        {
          prevEmploymentInfo:true,
          _id: 0,
          employerName: true,
          address: {
            line1: true,
            line2: true,
            aptType: true,
            locationId: true,
            locationDetails: true,
            stateId: true,
            stateDetails: true,
            countryId: true,
            countryDetails: true,
            zipcode: true,
          },
          businessType: true,
          jobTitle: true,
          jobDuties: true,
          startDate: true,
          endDate: true,
          currentEmployer: true,
          h1bEmployerDocuments:true,
          workPhoneNumber: true,
          workPhoneCountryCode: {
            countryCode: true,
            countryCallingCode: true,
          },
          fax: true,
          faxCountryCode: {
            countryCode: true,
            countryCallingCode: true,
          },
          hoursWorkedPerWeek: true,
          supervisor: {
            name: true,
            phoneNumber: true,
            phoneCountryCode: {
              countryCode: true,
              countryCallingCode: true,
            },
          },
        },
      ],
      
      /*OLD*/
      currentlyInUS: true,
      haveOwnershipInterest: true,
      ownershipInterestDesc: true,
      consulateInfo: {
        locationId: true,
        locationDetails: true,
        stateId: true,
        stateDetails: true,
        countryId: true,
        countryDetails: true,
      },
      lastArrivalNumber: true,
      placeOfLastEntryInUS: true,
      nonImmPetitionsInfo: [
        {
          _id: 0,
          visaStatus: true,
          visaStatusDetails: true,
          receiptNo: true,
          petitionerName: true,
        },
      ],
      anyImmPetitionFiled: true,
      immPetitionInfo: {
        anyOtherAlienFiled: true,
        filedDate: true,
        employerName: true,
        rirOrRegularProcessing: true,
        filedStateId: true,
        filedStateDetails: true,
        applCurStatus: true,
        seekingFiledDateforETA750: true,
      },
      addressOutsideUS: {
        line1: true,
        line2: true,
        aptType: true,
        locationId: true,
        locationDetails: true,
        stateId: true,
        stateDetails: true,
        countryId: true,
        countryDetails: true,
        zipcode: true,
      },
      hasOtherNames: true,
      otherNames: [
        {
          _id: 0,
          name: true,
          firstName: true,
          middleName: true,
          lastName: true,
        },
      ],
      // gender: true,
      maritalStatus: true,
      I94: true,
      I94ExpiryDate: true,
      iAmFromUS: true,
      consulateNotifyAddress: true,
      hasI140ImmPetitionFiled: true,
      I140ImmPetitionFiledDetails: true,
      passportNumber: true,
      passportIssuedNumber: true,
      passportExpiryNumber: true,
      sevisNumber: true,
      eadNumber: true,
      noOfDaysStayInUS: true,
      confirmDaysStayInUS: true,
      hasApprovedI140: true,
      hasPermPendingForMorethan365Days: true,
    },
    alienInfo: {
        isTrainigRequired: true,
        isExpRequired: true,
        isAltCombOfEduAndExpAccept: true,
        acceptAnyCombination:true,
        isExpInAltOccuAccept: true,
        hasGainAnyExpWithEmplr: true,
        didEmplrPayForEdu: true,
        isWorkingWithPetngEmplr: true,
      },
      refilingInstructions: {
        useFilingDateFromPrevSubtn: true,
        prevFilingDate: true,
        prevSWAOrLocalCaseNo: true,
        caseFiledStateId: true,
        caseFiledStateDetails: true,
      },
    documents: {
      slgResume: true,
      slgEduCredentials: true,
      slgEvalOfEduCredentials: true,
      slgTransScripts: true,
      slgExpLetters: true,
      slgPassportAndVisa: true,
      slgI94:true,
      slgCurPrevH1BH4ApprovalsByINS: true,
      slgAdvancedDegrees: true,
      resume:true,
      slgPrevLaborApplications:true,
      slgAckOfPrevLaborApplications:false,

      expLetters:true,
      passportVisaI94:true,
      slgPrevNonimmApprovalNotices:true,
    },
    dependentsInfo:{
      spouse:{
        hasSpouse:true,
        gender: true,
        email: true,
        phoneNumber: true,
        cellPhoneNumber: true,
        provinceOfBirth: true,
        locationOfBirth: true,
        isDSExpiryDate: true,
        firstName: true,
        middleName: true,
        lastName: true,
        maidenName: true,
        dateOfBirth: true,
        countryOfBirth: true,
        countryOfCitizenship: true,
        otherCountriesOfCitizenship: true,
        currentStatus: true,
        statusExpiryDate: true,
        passportNumber: true,
        passportIssuedCountry: true,
        passportExpiryDate: true,
        passportIssuedDate: true,
        SSN: true,
        addressOutsideUS: true,
      },
      childrens:{
        hasChildren:true,
        gender: true,
        email: true,
        phoneNumber: true,
        cellPhoneNumber: true,
        provinceOfBirth: true,
        locationOfBirth: true,
        isDSExpiryDate: true,
        firstName: true,
        middleName: true,
        lastName: true,
        dateOfBirth: true,
        countryOfBirth: true,
        placeOfBirth: true,
        countryOfCitizenship: true,
        otherCountriesOfCitizenship: true,
        currentStatus: true,
        statusExpiryDate: true,
        passportNumber: true,
        passportIssuedCountry: true,
        passportExpiryDate: true,
        passportIssuedDate: true,
        SSN: true,
        addressOutsideUS: true,
        maidenName:true,
      },
    },
    isEveryThingLoaded:false,
    fields: [
    
    {
          key: "previouslyMarried",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo",
        },
        
        {
          key: "marriageEndedDueTo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
    {
          key: "previousSpouse",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "firstName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "middleName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "lastName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "name",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "maidenName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfBirth",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "dateOfMarriageEnd",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "locationOfMarriage",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "countryOfMarriageTerminationDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "provinceOfMarriageTerminationDetails",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "locationOfMarriageTermination",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "obtainPermResidenceThroughSpouse",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
        {
          key: "marriageEndedOtherInfo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.previousSpouse",
        },
    {
        key: "isTrainigRequired",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isExpRequired",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      }, 
      {
        key: "acceptAnyCombination",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isAltCombOfEduAndExpAccept",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isExpInAltOccuAccept",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "hasGainAnyExpWithEmplr",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "didEmplrPayForEdu",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "isWorkingWithPetngEmplr",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "alienInfo",
      },
      {
        key: "useFilingDateFromPrevSubtn",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "prevFilingDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "prevSWAOrLocalCaseNo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "refilingInstructions",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "firstName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "middleName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "lastName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "email",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "gender",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "currentAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "mailingAddressIsSameAsAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "mailingAddress",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "homePhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "homePhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "cellPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "workPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "workPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "fax",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "faxCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfBirthDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "provinceOfBirthDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },

      {
        key: "countryOfCitizenship",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "countryOfCitizenshipDetails",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "haveYouEverTravelledToUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "priorPeriodOfStayInUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      
      {
        key: "noOfDaysStayInUS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "curNonImmigrantVisaStatus",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "curVisaExpiryDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "I94",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "I94ExpiryDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "firstEntryDateOrApprovalInUsWithH1B",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "dateFifthYearOfHExpire",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "alienNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      {
        key: "SSN",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo",
      },
      //
      {
          key: "immPetitionInfo",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo",
        },
      {
          key: "anyOtherAlienFiled",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "filedDate",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "employerName",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "rirOrRegularProcessing",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "filedStateId",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "applCurStatus",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
        {
          key: "seekingFiledDateforETA750",
          lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "beneficiaryInfo.immPetitionInfo",
        },
       
      //
      {
        key: "prevEmploymentInfo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
     
      {
        key: "employerName",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "workPhoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "workPhoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "fax",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "faxCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "businessType",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobTitle",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobDuties",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "jobDescription",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "startDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "endDate",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "hoursWorkedPerWeek",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "currentEmployer",
        lebel: "",
        fieldRequired:true,
        required: true,

        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "currentH1BEmployer",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "h1bEmployerDocuments",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      }, 
      
      
      //prevEmploymentInfo.supervisor
      {
        key: "salary",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "payFrequency",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo.supervisor",
      },
      {
        key: "phoneNumber",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfo.supervisor",
      },
      {
        key: "phoneCountryCode",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.prevEmploymentInfosupervisor",
      },
      
      //educations fields
      {
        key: "educations",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "highestDegree",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "majorFieldOfStudy",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "attendedFrom",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "attendedTo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "graduatedYear",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "isAccredited",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      {
        key: "isForProfit",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.educations",
      },
      //beneficiaryInfo.vacationalOrTrainingInst
     
      //vacaionalOrTrainingInst fields vacationalOrTrainingInst
      {
        key: "vacationalOrTrainingInst",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "name",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "address",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "highestDegree",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "majorFieldOfStudy",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "attendedFrom",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "attendedTo",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "graduatedYear",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "isAccredited",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      {
        key: "isForProfit",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "beneficiaryInfo.vacationalOrTrainingInst",
      },
      
      //documents
      {
        key: "resume",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "expLetters",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "passportVisaI94",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgResume",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgEduCredentials",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgEvalOfEduCredentials",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgTransScripts",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgPrevLaborApplications",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgAckOfPrevLaborApplications",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      
      {
        key: "slgPrevNonimmApprovalNotices",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgExpLetters",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      
      {
        key: "slgPassportAndVisa",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgI94",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgCurPrevH1BH4ApprovalsByINS",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "slgAdvancedDegrees",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "other",
        lebel: "",
        fieldRequired:true,
        required: true,
        description: "",
        section: "documents",
      },
      {
        key: "hasSpouse",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "firstName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "lastName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "maidenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "gender",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "email",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "phoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "isDSExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "placeOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "otherCountriesOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "currentStatus",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "statusExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportIssuedCountry",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "SSN",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "addressOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.spouse",
      },
      {
        key: "hasChildren",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "firstName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "middleName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "lastName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "maidenName",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "gender",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "email",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "phoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "cellPhoneNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "provinceOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "isDSExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "locationOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "dateOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "countryOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "placeOfBirth",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "countryOfCitizenship",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "otherCountriesOfCitizenship",
        lebel: "",
          required: true,
          description: "",
          fieldRequired:true,
          section: "dependentsInfo.childrens",
        },
      {
        key: "currentStatus",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "statusExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportNumber",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportIssuedCountry",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportExpiryDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "passportIssuedDate",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "SSN",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
      {
        key: "addressOutsideUS",
        lebel: "",
        required: true,
        description: "",
        fieldRequired:true,
        section: "dependentsInfo.childrens",
      },
    ],
    dbFields: [],
    responseFields: [],
    PayloadData: {
      name: "",
      questionnaireId: "",
      fields: [],
      sections: [],
    },
    configId: null,
    configDetails: null,
  }),
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  components: {
    VuePhoneNumberInput,
    Datepicker,
    FileUpload,
    Trash2Icon,
    InfoIcon,
    EyeIcon,
  },
  computed:{
    checkSpouseLabel(){
      return (data)=>{
        let returnVal =  true
        let tempSection = data['section']
        if(this.isEdit == false){
          let previousSpouseKeys =['obtainPermResidenceThroughSpouse','marriageEndedOtherInfo','marriageEndedDueTo','locationOfMarriageTermination','provinceOfMarriageTermination',
          'countryOfMarriageTermination','locationOfMarriage','provinceOfMarriage','countryOfMarriage','dateOfMarriageEnd','dateOfMarriage',
          'dateOfBirth','maidenName','lastName','middleName','firstName']
          let filteredKeys = _.filter(this.dbFields,(field)=>{
            return previousSpouseKeys.indexOf(field.key) >-1 && field['section'] == tempSection
          })
          if(filteredKeys && this.checkProperty(filteredKeys,'length')>0){
            returnVal = true
          }
          else{
            returnVal = false
          }
        }
        return returnVal
      }
    },
    checkFieldRequired(){
     return (data)=>{

      let item = _.find(this.fields,{"section":data.section , "key":data.key});
      
      if(item && _.has(item ,"fieldRequired") && item.fieldRequired){
        return true;
      }else{
        return false;
      }
  }

},
     checkActiveTab(){
          return  _.findIndex(this.tabslist ,{"key":this.currentTab});
      },  
      getIndexOfActivetab() {
          var $self = this;
              return _.findIndex(this.tabslist, (e) => {
                  return e.key == $self.currentTab;
              }) + 1;
          },
  },
  methods: {
    showOrHideField({section= '',key= ''}){
    let localSection = section
    let localKey = key
    if(this.isEdit){
      return true
    }else if(this.checkProperty(this.dbFields, "length") > 0) {
      let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
      if(dbItem){
        return true
      }
      else {
        return false
      }
    }else{
      return true
    }

   },
    toogleFields({section= '',key= ''}){
      _.map(this.fields,(item)=>{
        if(item.section==section && item.key==key ){
          item.fieldRequired?item.fieldRequired=false:item.fieldRequired =true
          if(item.fieldRequired == false || item.fieldRequired == 'false' ){
            _.update(this, section + "." + key, () => false);
          }
        }
      });
      this.fields = _.cloneDeep(this.fields);
    },

    goBack() {
                this.setActiveTab(this.tabslist[this.getIndexOfActivetab - 2].key)
    
    },
     selectCheck({ section = "", subSection = "", key = "" }) {
      
      let fieldIndex = _.findIndex(this.fields, { section: section, key: key });
      if (fieldIndex > -1) {
        let Item = _.cloneDeep(this.fields[fieldIndex]);
       Item["required"] =  _.get(this ,section+'.'+key ,true);
       this.fields[fieldIndex] = Item;
      } else {
        let newItem = {
          key: key,
          lebel: "First Name",
          required: _.get(this ,section+'.'+key ,true),
          description: "",
          section: section,
        };
        this.fields.push(newItem);
      }
      this.fields = _.cloneDeep(this.fields);
    },
    finalSubmit() {
      this.showFinalsubmitPopup = true;
    },
    // processDbFields() {
    //   let self = this;
    //   if (this.checkProperty(this.dbFields, "length") > 0) {
    //     _.forEach(this.dbFields, (dbItem) => {
    //       let dbsection = this.checkProperty(dbItem, "section");
    //       let dbkeyFiled = this.checkProperty(dbItem, "key");
    //       if (dbsection && dbkeyFiled) {
    //         _.map(self.fields, (item) => {
    //           if (dbkeyFiled == item["key"] && dbsection == item["section"]) {
    //             item["required"] = dbItem["required"];
    //           }
    //         });
    //         _.update(self, dbsection + "." + dbkeyFiled, () => dbItem["required"]);
    //       }
    //     });
    //   }
    // },
    processDataFields(){
      let self = this;
      try{
        if (this.checkProperty(this.dbFields, "length") > 0) {
        _.forEach(self.fields, (item)=>{
          let localItem = item
          let localSection = this.checkProperty(localItem,'section')
          let localKey = this.checkProperty(localItem,'key')
          let dbItem = _.find(this.dbFields, {'section':localSection,'key':localKey})
          item['fieldRequired'] = false;
          item['required'] = false;
          _.update(self,localSection+'.'+localKey ,()=>false)
          if(dbItem){
            item['fieldRequired'] = true;
            if(this.checkProperty(dbItem, 'required') || this.checkProperty(dbItem, 'required') == 'true' ){
              item['required'] = true;
            }
            else{
              item['required'] = false;
            }
            _.update(self,localSection+'.'+localKey ,()=>dbItem['required'])
          }
        })
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      this.isEveryThingLoaded = true
      this.$vs.loading.close()
      }catch{
        this.isEveryThingLoaded = true
        this.$vs.loading.close()
      }
      
    },
    getConfigDetails() {
      let postData = { questionnaireId: this.configId };
      this.isEveryThingLoaded = false
      this.$vs.loading();
      this.$store
        .dispatch("commonAction", { data: postData, path: "/questionnaire/details" })
        .then((res) => {
          this.configDetails = res;
          this.PayloadData["name"] = res.name;
          this.PayloadData["questionnaireId"] = this.configId;
          this.dbFields = this.configDetails.fields;
          //this.processDbFields();
          this.processDataFields();
        }).catch((err)=>{
          this.isEveryThingLoaded = true
          this.$vs.loading.close()
        });
    },
    saveMe(isFinalSUbmit = false) {
      
      let PayloadData = _.cloneDeep(this.PayloadData);
      if (_.has(PayloadData, "questionnaireId")) {
        PayloadData["questionnaireId"] = this.configId;
      }
      if (_.has(PayloadData, "name")) {
        PayloadData["name"] = this.PayloadData["name"];
      }
      // if (_.has(PayloadData, "fields")) {
      //   PayloadData["fields"] = _.sortedUniq(this.fields);
      // }
      if (_.has(PayloadData, "sections")) {
        PayloadData["sections"] = _.sortedUniq(PayloadData.sections);
      }
      if (isFinalSUbmit) {
        PayloadData = Object.assign(PayloadData, { configCompleted: true });
        PayloadData["configCompleted"] = true;
      }
      if (this.configDetails.tenantId) {
        PayloadData = Object.assign(PayloadData, {
          tenantId: this.configDetails.tenantId,
        });
      }
      if(_.has(PayloadData, "fields")){
        PayloadData["fields"] = _.filter(this.fields ,(item)=>{
          return item['fieldRequired'] == true || item['fieldRequired'] == 'true' ;
        })
      }

      this.$store
        .dispatch("commonAction", {
          data: PayloadData,
          path: "/questionnaire/update",
        })
        .then((res) => {
          this.showToster({ message: res.message, isError: false });
          this.showFinalsubmitPopup = false;
          this.getConfigDetails();

          setTimeout(() => {
            if (this.templateId) {
              this.$emit("gotoList");
            } else {
              this.$router.push("/questionnaire-templates-list");
            }
          }, 10);
        })
        .catch((err) => {
          this.showToster({ message: err, isError: true });
        });
    },
  },
  mounted() {
    this.configId = this.$route.params.id;
    if (this.templateId) {
      this.configId = this.templateId;
    }
    this.getConfigDetails();
    // this.processDbFields();
  },
};
</script>
